import { ReactNode, useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider, useAuth } from '../utils/authcontextt';
import { DocumentsProvider } from './DocumentsProvider';

type AppProvidersProps = {
  children: ReactNode;
};

const AuthenticatedProviders = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  const [queryClient, setQueryClient] = useState(() => new QueryClient());

  useEffect(() => {
    if (user) {
      setQueryClient(new QueryClient());
    } else {
      queryClient.clear();
    }
  }, [user]);

  return (
    <QueryClientProvider client={queryClient}>
      <DocumentsProvider>
        {children}
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      </DocumentsProvider>
    </QueryClientProvider>
  );
};

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <AuthProvider>
      <AuthenticatedProviders>{children}</AuthenticatedProviders>
    </AuthProvider>
  );
};
